
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import {
  ROLES,
  normalizeRole,
  getDefaultRouteForRole
} from '../services/roleManagementService';

const PrivateRoute = ({ children, allowedRoles = [], requireRole = false, requirePermission = null }) => {
  const { currentUser, userProfile } = useAuth();

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  // If no role requirements specified, allow any authenticated user
  if (!requireRole && (!allowedRoles || allowedRoles.length === 0)) {
    return children;
  }

  // If role requirements specified, check user profile
  if (!userProfile) {
    return <Navigate to="/login" />;
  }

  // Check verification requirement
  const normalizedRole = normalizeRole(userProfile.role);
  const role = ROLES[normalizedRole?.toUpperCase()];
  if (role?.restrictions?.requiresVerification && !userProfile.isVerified) {
    return (
      <div className="container mt-5">
        <div className="alert alert-warning">
          <h4>Account Verification Required</h4>
          <p>Your account is pending verification. Please check your email or contact an administrator.</p>
        </div>
      </div>
    );
  }

  // Check if user role is allowed
  const normalizedAllowedRoles = (allowedRoles || []).map(normalizeRole);
  if (allowedRoles && allowedRoles.length > 0 && !normalizedAllowedRoles.includes(normalizedRole)) {
    return <Navigate to={getDefaultRouteForRole(normalizedRole)} replace />;
  }

  return children;
};

export default PrivateRoute;
